import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, xcss } from '@atlaskit/primitives';
import Select from '@atlaskit/select';
import React from 'react';
import { charlieTextFontFamily } from '../../../FontFamily';
import { CustomControl } from '../Control';
import { CustomDropdownIndicator } from '../DropdownIndicator';
import { Footer } from '../Footer';
import { CustomMenu } from '../Menu';
import { CustomNoOptionsMessage } from '../NoOptionsMessage';
import { CustomOption } from '../Option';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const customSelectStyles = {
  control: base => _objectSpread(_objectSpread({}, base), {}, {
    border: 0 // Removing the default border around the select control
  })
};
const customComponents = {
  Option: CustomOption,
  DropdownIndicator: CustomDropdownIndicator,
  Menu: CustomMenu,
  Control: CustomControl,
  NoOptionsMessage: CustomNoOptionsMessage
};
const selectWrapperStyles = xcss(_objectSpread(_objectSpread({}, charlieTextFontFamily), {}, {
  width: '280px'
}));
export const FilterPickerSelect = _ref => {
  let {
    testId,
    options,
    selectedOptions,
    status,
    searchInputValue,
    isMulti = false,
    isSearchable = false,
    hasClearSelectionButton = false,
    onSelectionChange,
    onClearSelection,
    onSearchInputChange,
    onSelectKeyDown,
    onHandleFocus
  } = _ref;
  return /*#__PURE__*/_jsxs(Box, {
    xcss: selectWrapperStyles,
    children: [/*#__PURE__*/_jsx(Select, {
      placeholder: "Search",
      testId: testId,
      options: options,
      value: selectedOptions,
      isMulti: isMulti,
      onChange: onSelectionChange,
      inputValue: searchInputValue,
      onInputChange: onSearchInputChange,
      components: customComponents,
      styles: customSelectStyles,
      autoFocus: true,
      menuIsOpen: true
      // If single select, we want to blur the input when a selection is made, so that the page doesn't scroll to the Portal (which is rendered at the bottom of the page)
      ,
      blurInputOnSelect: !isMulti,
      closeMenuOnSelect: false,
      hideSelectedOptions: false,
      controlShouldRenderValue: false,
      menuShouldScrollIntoView: false,
      tabSelectsValue: false,
      defaultOptions: false,
      isClearable: false,
      escapeClearsValue: false,
      isSearchable: isSearchable,
      status: status,
      onKeyDown: onSelectKeyDown,
      onFocus: onHandleFocus
    }), status === 'default' && hasClearSelectionButton && onClearSelection && /*#__PURE__*/_jsx(Footer, {
      isClearSelectionDisabled: selectedOptions.length === 0,
      onClearSelection: onClearSelection
    })]
  });
};